import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between mb-5" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Export Catalogs ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Export Dropship Catalogs ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Export POD Catalogs ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Import Supplier Codes ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Import Supplier Codes ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Import History ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Clear Cache ")
const _hoisted_10 = {
  key: 0,
  class: "text-center text-2xl font-semibold"
}
const _hoisted_11 = {
  key: 1,
  class: "mb-4 grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-5 gap-3 w-full"
}
const _hoisted_12 = { class: "flex justify-end mb-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_Download = _resolveComponent("Download")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_UploadFilled = _resolveComponent("UploadFilled")!
  const _component_FilterArea = _resolveComponent("FilterArea")!
  const _component_ItemCard = _resolveComponent("ItemCard")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_CatalogFromUrlDialog = _resolveComponent("CatalogFromUrlDialog")!
  const _component_ImportSupplierCodeDialog = _resolveComponent("ImportSupplierCodeDialog")!
  const _component_HistoryDialog = _resolveComponent("HistoryDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    onActionCreate: _ctx.create,
    onActionImport: _ctx.createDropship,
    onActionOtherButton1: _ctx.onCreateByUrl
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_page_title, { title: "Agency Catalogue" }),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isAccounting)
            ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalExport('drop')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalExport('pod')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Download)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isAccounting)
            ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 1 }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, { onClick: _ctx.onImportSupplierCodes }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_dropdown_item, { onClick: _ctx.openHistoryDialog }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UploadFilled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClearCachePublicCatalog())),
            title: "Clear product catalog cache in lattex.co"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_FilterArea, {
        params: _ctx.params,
        onClearFilters: _ctx.clearFilters
      }, null, 8, ["params", "onClearFilters"]),
      (!_ctx.catalogs.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " No data "))
        : (_openBlock(), _createElementBlock("section", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogs, (product, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "mb-6 basis-fit bg-white rounded-lg h-full"
              }, [
                _createVNode(_component_ItemCard, { product: product }, null, 8, ["product"])
              ]))
            }), 128))
          ])),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_pagination, {
          total: _ctx.total,
          pagination: _ctx.params.page,
          "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.page) = $event)),
          limit: _ctx.params.limit,
          "onUpdate:limit": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.limit) = $event))
        }, null, 8, ["total", "pagination", "limit"])
      ]),
      _createVNode(_component_CatalogFromUrlDialog, {
        ref: "catalogFromUrlDialog",
        onOnAfterCreateCatalog: _ctx.getData
      }, null, 8, ["onOnAfterCreateCatalog"]),
      _createVNode(_component_ImportSupplierCodeDialog, { ref: "importSupplierCodeDialog" }, null, 512),
      _createVNode(_component_HistoryDialog, { ref: "historyDialog" }, null, 512)
    ]),
    _: 1
  }, 16, ["onActionCreate", "onActionImport", "onActionOtherButton1"])), [
    [_directive_loading, _ctx.loading]
  ])
}